const SHL_MARKER = 'shlink:/';

export const getLegacyShlinkRedirectUrl = ({
  origin,
  pathname,
  search,
  hash,
}) => {
  const markerIndex = pathname.indexOf(SHL_MARKER);
  if (hash.includes(SHL_MARKER) || markerIndex === -1) {
    return null;
  }

  const afterMarker = pathname.slice(markerIndex + SHL_MARKER.length);
  const [payload, section] = afterMarker.split('/');
  const params = new URLSearchParams(search);
  if (section) {
    params.set('section', section);
  }
  const query = params.toString();

  return `${origin}/${query ? `?${query}` : ''}#${SHL_MARKER}${payload}`;
};

export const getShlFromFragment = ({ hash }) => {
  if (!hash.startsWith(`#${SHL_MARKER}`)) {
    return null;
  }
  return hash.slice(SHL_MARKER.length + 1).split(/[/?#]/)[0] || null;
};
